exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".component-page-organization-info[data-v-e9c5d84c]{color:#5b5b5b;font-size:14px;font-weight:400;line-height:1.4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e9c5d84c","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/page/organization/info/component.vue
// module id = 6def0aa1faf10697245a
// module chunks = 0